var _templateObject = _taggedTemplateLiteralLoose(["\n      margin-bottom: 0;\n      padding-right: 2em;\n    "], ["\n      margin-bottom: 0;\n      padding-right: 2em;\n    "]);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Fragment } from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";

import Segment from "./Segment";
import Link from "./Link";
import Text from "./Text";
import IconYoutube from "../icons/IconYoutube";
import IconFacebook from "../icons/IconFacebook";
import IconLinkedin from "../icons/IconLinkedin";
import IconInstagram from "../icons/IconInstagram";
import { colors } from "..";
import { media } from "../mixins";

var FooterWrapper = styled(Segment).withConfig({
  displayName: "Footer__FooterWrapper",
  componentId: "sc-1njmkh2-0"
})(["background-color:", ";color:", ";font-size:1em;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor ? backgroundColor : colors.darkNavy;
}, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor ? textColor : colors.white;
});

var LinksTitle = styled(Text).withConfig({
  displayName: "Footer__LinksTitle",
  componentId: "sc-1njmkh2-1"
})(["text-transform:uppercase;font-weight:bold;line-height:2em;letter-spacing:1px;"]);

var LinksGroupWrapper = styled(Flex).withConfig({
  displayName: "Footer__LinksGroupWrapper",
  componentId: "sc-1njmkh2-2"
})(["&:not(:last-child){margin-bottom:2em;", "}}"], media.desktop(_templateObject));

var LinkWrapper = styled(Box).withConfig({
  displayName: "Footer__LinkWrapper",
  componentId: "sc-1njmkh2-3"
})(["&:not(:last-child){margin-bottom:1em;}"]);

var StyledLink = styled(Link).withConfig({
  displayName: "Footer__StyledLink",
  componentId: "sc-1njmkh2-4"
})(["color:white;font-weight:normal;"]);

var SocialMediaIcon = styled.div.withConfig({
  displayName: "Footer__SocialMediaIcon",
  componentId: "sc-1njmkh2-5"
})(["margin-right:0.75rem;width:36px;height:36px;display:", ";"], function (_ref3) {
  var hidden = _ref3.hidden;
  return hidden && "none";
});

var Footer = function Footer(_ref4) {
  var links = _ref4.links,
      backgroundColor = _ref4.backgroundColor,
      textColor = _ref4.textColor,
      countryPicker = _ref4.countryPicker,
      social = _ref4.social,
      props = _objectWithoutProperties(_ref4, ["links", "backgroundColor", "textColor", "countryPicker", "social"]);

  return React.createElement(
    FooterWrapper,
    { backgroundColor: backgroundColor, textColor: textColor },
    React.createElement(
      Flex,
      {
        justifyContent: "space-between",
        my: "3em",
        flexDirection: ["column-reverse", "column-reverse", "row"]
      },
      React.createElement(
        Box,
        { width: ["100%", "100%", 1 / 2], pr: ["0", "0", "10em"] },
        countryPicker && React.createElement(
          Box,
          { mb: "2em" },
          countryPicker
        ),
        React.createElement(
          Box,
          { mb: "4.5em" },
          React.createElement(SocialLinks, { social: social })
        ),
        props.children
      ),
      React.createElement(FooterLinks, { links: links })
    )
  );
};

var FooterLinks = function FooterLinks(_ref5) {
  var links = _ref5.links;
  return React.createElement(
    Flex,
    {
      width: ["100%", "100%", 1 / 2],
      mb: ["3.5em", "3.5em", "0"],
      flexWrap: ["wrap"]
    },
    links.map(function (item) {
      return React.createElement(
        LinksGroup,
        { key: item.linksTitle, title: item.linksTitle },
        React.createElement(LinksItems, { items: item.items })
      );
    })
  );
};

var LinksGroup = function LinksGroup(_ref6) {
  var title = _ref6.title,
      items = _ref6.items,
      props = _objectWithoutProperties(_ref6, ["title", "items"]);

  return React.createElement(
    LinksGroupWrapper,
    { width: [1 / 2, 1 / 2, 1 / 3], flexDirection: "column" },
    React.createElement(
      Box,
      { mb: "1.25em" },
      React.createElement(
        LinksTitle,
        null,
        title
      )
    ),
    props.children
  );
};

var LinksItems = function LinksItems(props) {
  return React.createElement(
    Fragment,
    null,
    props.items.map(function (item, i) {
      if (item.link.match(/^https?/)) {
        return React.createElement(
          LinkWrapper,
          { key: item.text },
          React.createElement(
            StyledLink,
            { rel: "noopener noreferrer", key: i, href: item.link },
            item.text
          )
        );
      } else {
        return React.createElement(
          LinkWrapper,
          { key: item.text },
          React.createElement(
            StyledLink,
            { href: item.link },
            item.text
          )
        );
      }
    })
  );
};

var SocialLinks = function SocialLinks(_ref7) {
  var social = _ref7.social;
  return React.createElement(
    Flex,
    null,
    social.instagram && React.createElement(
      "a",
      { rel: "noreferrer noopener", href: social.instagram, target: "_blank" },
      React.createElement(
        SocialMediaIcon,
        null,
        React.createElement(IconInstagram, null)
      )
    ),
    social.facebook && React.createElement(
      "a",
      { rel: "noreferrer noopener", href: social.facebook, target: "_blank" },
      React.createElement(
        SocialMediaIcon,
        null,
        React.createElement(IconFacebook, null)
      )
    ),
    social.linkedin && React.createElement(
      "a",
      {
        rel: "noreferrer noopener",
        href: "https://www.linkedin.com/company/anyfin/",
        target: "_blank"
      },
      React.createElement(
        SocialMediaIcon,
        null,
        React.createElement(IconLinkedin, null)
      )
    ),
    social.youtube && React.createElement(
      "a",
      { rel: "noreferrer noopener", href: social.youtube, target: "_blank" },
      React.createElement(
        SocialMediaIcon,
        null,
        React.createElement(IconYoutube, null)
      )
    )
  );
};

export default Footer;